/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-05-08 14:46:50
 * @LastEditors: changfeng
 * @LastEditTime: 2024-05-08 15:24:21
 */

export default {
	ar: "Arabic",
	as: "Assamese",
	bgc: "Haryanvi",
	bh: "Bihari",
	bn: "Bengali",
	cs: "Czech",
	de: "German",
	el: "Greek",
	en: "English",
	es: "Spanish",
	fi: " Finnish",
	fr: "French",
	gu: "Gujarati",
	he: "Hebrew",
	hi: "Hindi",
	hu: "Hungarian",
	id: "Indonesian",
	it: "Italian",
	ja: "Japanese",
	km: "Khmer ",
	kn: "Kannada",
	ko: "Korean",
	ml: "Malayalam",
	mr: "Marathi",
	ms: "Malay",
	nl: " Dutch",
	or: "Oriya",
	pa: "Punjabi",
	pl: "Polish",
	pt: "Portuguese",
	raj: "Rajasthani",
	ro: "Romanian",
	ru: "Russian",
	sv: "Swedish",
	ta: "Tamil",
	te: "Telugu",
	th: "Thai",
	tr: "Turkish",
	uk: "Ukrainian",
	vi: "Vietnamese",
	"zh-Hant": "Traditional Chinese"
};
